// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5fb7630","265":"f709dccf"}[chunkId] + ".chunk.js";
};